import { ApiRequestParams } from './global-interfaces';
import { Credentials } from './credentials.model';
import { components, operations } from 'be-types';
import { DataScope } from './global-enum';

export const userTableApiRequestParams: ApiRequestParams = {
  dataScope: DataScope.UserTable,
  locationID: 0,
};

export type LoginResponse = operations['login']['responses']['200']['content']['application/json'];
export type RefreshTokenResource = components['schemas']['RefreshTokenResource'];
export type UserLoginRequest = components['schemas']['UserLoginRequest'];
export type ChangePasswordRequest = components['schemas']['ChangePasswordRequest'];
export type ResetPasswordLinkRequest = components['schemas']['ResetPasswordLinkRequest'];
export type UpdateUserRequest = components['schemas']['UpdateUserRequest'];
export type GlobalPermissionsResource = components['schemas']['GlobalCredResource'];
export type LocationCredResource = components['schemas']['LocationCredResource'];
export type RoleResource = components['schemas']['RolesResource'];
export type UserResource = components['schemas']['UserInfoResource'];
export type CustomerResource = components['schemas']['CustomerResource'];
export type RoleUserResource = components['schemas']['UserAndRolesUserResource'];
export type UserInfoResource = components['schemas']['UserUserInfoResource'];
export type CreateUserRequest = components['schemas']['StoreUserRequest'];
export type UserWithPermissionsResource = components['schemas']['ShowUserResource'];
export type LocalUserRescource = components['schemas']['LocalUserResource'];
export type DefaultAssignee = components['schemas']['DefaultTaskAssigneeResource'];
export type UserMinimum = Pick<UserResource['userInfo'], 'id' | 'userFullName'>;

export enum SSO_OPTIONS {
  OKTA = 'OKTA',
  AZURE = 'AZURE',
}

export interface TableUser {
  id: number;
  locationAndRole: string;
  userActive: boolean;
  userCredentials: Credentials[];
  userFullName: string;
  isAzureUser: boolean;
  selected?: boolean;
  completeSelected?: boolean;
  userEmail: string;
}

export interface TaskUserPreview {
  userFullName: string;
  userID: number;
}

export interface Customer {
  customerName: string;
}
